// extracted by mini-css-extract-plugin
export default {"modifier":"styles_modifier__ecyZh","signedNumber":"styles_signedNumber__hCdrI","icon":"styles_icon__Teo4H","description":"styles_description__jru+3"};